var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { staticClass: "payment-summary fsize-13 color-grey4" },
    [
      +_vm.order.ProcessingFee
        ? _c("li", { staticClass: "flex-between-end" }, [
            _c("div", [_vm._v("Frais de gestion")]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.prix(_vm.order.ProcessingFee)))]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.order.ShippingFee
        ? _c("li", { staticClass: "flex-between-end" }, [
            _c("div", [_vm._v("Frais de livraison")]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.prix(_vm.order.ShippingFee)))]),
          ])
        : _vm._e(),
      _vm._v(" "),
      +_vm.order.Tip
        ? _c("li", { staticClass: "flex-between-end" }, [
            _c("div", [_vm._v("Pourboire")]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.prix(_vm.order.Tip)))]),
          ])
        : _vm._e(),
      _vm._v(" "),
      +_vm.order.Discount
        ? _c("li", { staticClass: "flex-between-end color-bo-p2" }, [
            !_vm.order.promo_code ? _c("div", [_vm._v("Remise")]) : _vm._e(),
            _vm._v(" "),
            _vm.order.promo_code
              ? _c("div", [_vm._v(_vm._s(_vm.order.DiscountName))])
              : _vm._e(),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.prix(_vm.order.Discount)))]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass:
            "flex-between-end fsize-16 text-bold color-grey1 cursor-pointer mb-10",
          on: {
            click: function ($event) {
              _vm.showPayments = !_vm.showPayments
            },
          },
        },
        [
          _c(
            "div",
            [
              _vm._v("Total TTC "),
              _vm.order.payments
                ? _c("CollapseIndicator", { attrs: { open: _vm.showPayments } })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", [_vm._v(_vm._s(_vm.prix(_vm.order.Total)))]),
        ]
      ),
      _vm._v(" "),
      _c("CollapseTransition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showPayments,
                expression: "showPayments",
              },
            ],
          },
          [
            _vm.order.Remain && _vm.order.Remain != _vm.order.Total
              ? _c("li", { staticClass: "flex-between-end color-grey4" }, [
                  _c("div", [_vm._v("Déjà réglé")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "right",
                        "white-space": "nowrap",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.prix(-(_vm.order.Total - _vm.order.Remain)))
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.order.Subtotal != _vm.order.Total
              ? _c(
                  "li",
                  [
                    _c("div", { staticClass: "flex-between-end" }, [
                      _c("div", [_vm._v("Dont TVA")]),
                      _vm._v(" "),
                      _c("div", [_vm._v(_vm._s(_vm.prix(_vm.order.TotalTVA)))]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "flex-between-end" }, [
                      _c("div", [_vm._v("Total HT")]),
                      _vm._v(" "),
                      _c("div", [_vm._v(_vm._s(_vm.prix(_vm.order.TotalHT)))]),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.order.Tvas, function (tva) {
                      return _c("div", [
                        _vm._v(
                          "\n                    TVA " +
                            _vm._s(tva.Rate) +
                            " % " +
                            _vm._s(_vm.ttcToHt(tva.Amount, tva.Rate)) +
                            " HT " +
                            _vm._s(_vm.prix(tva.Amount)) +
                            " TTC\n                "
                        ),
                      ])
                    }),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.order.Remain
              ? _c(
                  "li",
                  {
                    staticClass: "flex-between-end fsize-16 text-bold color-2",
                  },
                  [
                    _c("div", [_vm._v("Reste à payer")]),
                    _vm._v(" "),
                    _c("div", { staticStyle: { "text-align": "right" } }, [
                      _vm._v(_vm._s(_vm.prix(_vm.order.Remain))),
                    ]),
                  ]
                )
              : _vm._e(),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }